module.exports = __webpack_public_path__ + "img/service_1.37570b8.png";